@if (!!fieldData) {
  <ziro-natural-language-editor
    [entity]="fieldData"
    [dataAutomation]="'call-forwarding-rules-field'"
    (entityUpdate)="updateSelf($event, true, fieldData)"
    (validationUpdate)="updateValidationState($event)"
  >
    <span
      [innerHTML]="
        'tkey;microsoft_360.view.teams.call_forward_settings.forwarding_rules.form.prefix'
          | escapeHtml: { displayName: userDisplayName() }
      "
    ></span>
    <ziro-natural-language-editor-single
      [options]="forwardingTypeOptions"
      [phraseId]="'forwardingType'"
    ></ziro-natural-language-editor-single>
    <span
      [innerHTML]="
        (fieldData.forwardingType === ForwardingRulesFieldForwardingType.SIMULTANEOUS
          ? 'tkey;microsoft_360.view.teams.call_forward_settings.forwarding_rules.form.conjunction.simultaneous'
          : 'tkey;microsoft_360.view.teams.call_forward_settings.forwarding_rules.form.conjunction.immediate'
        ) | escapeHtml
      "
    ></span>
    <ziro-natural-language-editor-double
      [options]="
        fieldData.forwardingType === ForwardingRulesFieldForwardingType.SIMULTANEOUS
          ? simultaneousForwardingTargetTypeOptions
          : immediateForwardingTargetTypeOptions
      "
      [primaryDropdownLabel]="
        fieldData.forwardingType === ForwardingRulesFieldForwardingType.SIMULTANEOUS
          ? 'tkey;microsoft_360.view.teams.call_forward_settings.forwarding_rules.form.target_type.simultaneous.label'
          : 'tkey;microsoft_360.view.teams.call_forward_settings.forwarding_rules.form.target_type.immediate.label'
      "
      [phraseId]="'forwardingTarget'"
    ></ziro-natural-language-editor-double>
  </ziro-natural-language-editor>
}
